import type { VoucherUnionNode, VoucherNewNode } from 'data-layer/src/lib/transformers/types';

/**
 * Type guard to check if voucher is VoucherNewNode.
 * VoucherNewNode has 'description' field, VoucherNode has 'subheadline' field.
 *
 * @param voucher - Voucher node to check
 * @returns True if voucher is VoucherNewNode
 */
function isVoucherNewNode(voucher: VoucherUnionNode): voucher is VoucherNewNode {
  return 'description' in voucher;
}

/**
 * Gets the description text from a voucher node.
 * Handles both VoucherNode (uses subheadline) and VoucherNewNode (uses description).
 *
 * @param voucher - Voucher union node (VoucherNode or VoucherNewNode)
 * @returns Description text for the voucher
 *
 * @example
 * ```typescript
 * // VoucherNewNode
 * const text = getVoucherDescription(voucherNew);
 * // Returns: voucherNew.description
 *
 * // VoucherNode
 * const text = getVoucherDescription(voucher);
 * // Returns: voucher.subheadline
 * ```
 */
export function getVoucherDescription(voucher: VoucherUnionNode): string {
  return isVoucherNewNode(voucher) ? voucher.description : voucher.subheadline;
}
